import type {ReactElement} from 'react'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import Filter from '@freckle/school/ts/manage-teachers/components/filter'
import type {StudentTabFilteringT} from '@freckle/school/ts/manage-teachers/components/student-tab/student-tab'

type Props = {
  currentSchoolIds: Array<number> | undefined | null
  studentTabFilter: StudentTabFilteringT | undefined | null
}

export default function StudentTabFilter(props: Props): ReactElement | null {
  const {studentTabFilter, currentSchoolIds} = props
  const {t} = useSafeTranslation()

  if (studentTabFilter === null || studentTabFilter === undefined) {
    return null
  }

  const url = Routes.dashboard({
    schoolIds: currentSchoolIds,
    activeTab: 'student-tab'
  })

  const {course, teacher, grade, source} = studentTabFilter

  if (course !== null && course !== undefined) {
    const name = `Students in ${course.name}`
    return <Filter name={name} url={url} />
  }

  if (teacher !== null && teacher !== undefined) {
    const name = `Students of ${teacher.name}`
    return <Filter name={name} url={url} />
  }

  if (grade !== null && grade !== undefined) {
    const name = t('STUDENT_FILTER_TEXT', {grade})
    return <Filter name={name} url={url} />
  }

  if (source !== null && source !== undefined) {
    const name =
      source === 'admin' ? 'Admin-created students' : 'Students created outside of an admin sync'
    return <Filter name={name} url={url} />
  }

  return null
}
